var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1131_2624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1131_2624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_2",
    d: "M11 14.277C10.8778 14.277 10.7632 14.2579 10.6562 14.2198C10.5493 14.1816 10.45 14.1166 10.3583 14.025L7.05832 10.725C6.87499 10.5416 6.78714 10.3277 6.79478 10.0833C6.80242 9.83885 6.89027 9.62496 7.05832 9.44163C7.24166 9.25829 7.45936 9.16281 7.71145 9.15517C7.96353 9.14753 8.18124 9.23538 8.36457 9.41871L10.0833 11.1375V4.58329C10.0833 4.32357 10.1712 4.10586 10.3469 3.93017C10.5226 3.75447 10.7403 3.66663 11 3.66663C11.2597 3.66663 11.4774 3.75447 11.6531 3.93017C11.8288 4.10586 11.9167 4.32357 11.9167 4.58329V11.1375L13.6354 9.41871C13.8187 9.23538 14.0364 9.14753 14.2885 9.15517C14.5406 9.16281 14.7583 9.25829 14.9417 9.44163C15.1097 9.62496 15.1976 9.83885 15.2052 10.0833C15.2128 10.3277 15.125 10.5416 14.9417 10.725L11.6417 14.025C11.55 14.1166 11.4507 14.1816 11.3437 14.2198C11.2368 14.2579 11.1222 14.277 11 14.277ZM5.49999 18.3333C4.99582 18.3333 4.56423 18.1538 4.2052 17.7948C3.84617 17.4357 3.66666 17.0041 3.66666 16.5V14.6666C3.66666 14.4069 3.7545 14.1892 3.9302 14.0135C4.10589 13.8378 4.3236 13.75 4.58332 13.75C4.84305 13.75 5.06075 13.8378 5.23645 14.0135C5.41214 14.1892 5.49999 14.4069 5.49999 14.6666V16.5H16.5V14.6666C16.5 14.4069 16.5878 14.1892 16.7635 14.0135C16.9392 13.8378 17.1569 13.75 17.4167 13.75C17.6764 13.75 17.8941 13.8378 18.0698 14.0135C18.2455 14.1892 18.3333 14.4069 18.3333 14.6666V16.5C18.3333 17.0041 18.1538 17.4357 17.7948 17.7948C17.4358 18.1538 17.0042 18.3333 16.5 18.3333H5.49999Z",
    fill: "#04B7EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.91ee70758a97206fed3a03890fae66ce.svg";
export { ForwardRef as ReactComponent };